import React, { useEffect, useState } from "react";
import "./contactus.css";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../../components/SelectButton";
import download from "../../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../../components/ReactTable";
import plus from "../../../assets/plus-square.png";
import editBond from "../../../assets/editBond.png";
import delBond from "../../../assets/deleteBond.png";
import CustomPagination from "../../../components/CustomPagination";
import axios from "axios";
import ReusableModal from "./ResuableModel";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function UserManagementMain() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Role Creation");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedReferal, setSelectedReferal] = useState(null);
  const [selectNumber, setSelectedNumber] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [error, setError] = useState(null);
  const [section, setSection] = useState("");
  const [text, setText] = useState("");
  const [link, setLink] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [newRole, setNewRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editRole, setEditRole] = useState({
    section: "",
    text: "",
    link: "",
  });

  const toastIds = {
    validationError: "validation-error-toast",
  };

  // Function to update multiple values
  const updateRole = (newValues) => {
    setEditRole((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setSection(newValues.section);
    setText(newValues.text);
    setLink(newValues.link);
    setIsModalOpenEdit(true); // Open the modal
  };

  const columnHelper = createColumnHelper();

  const handleClick = (path, label) => {
    setActiveTab(label);
    navigate(path); // Navigate to the given path
  };

  const handleSelectOccupation = (value) => {
    setSelectedOccupation(value);
  };

  const handleSelectReferal = (value) => {
    setSelectedReferal(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
  };

  const handleAdd = () => {
    // Handle form submission logic
    console.log({ section, text, link });
  };

  const handleCancel = () => {
    // Reset form fields
    setSection("");
    setText("");
    setLink("");
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/cms/contactUs`;
    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        // params: {
        //   page: page,
        //   search: searchInputApi,
        //   userType: "investor",
        //   status: "",
        // },
      });
      const sortedData =
        response?.data?.data?.contactUsData?.sort((a, b) => a.id - b.id) || [];
      console.log("sortedData", response?.data?.data?.contactUsData);

      // Update state with the sorted data
      setInvestorDetails(sortedData);

      // Safely access pagination-related fields or set defaults
      const totalPages = response?.data?.data?.totalPages || 0;
      const currentPage = response?.data?.data?.currentPage || 1;
      const totalRecords = response?.data?.data?.totalRecords || 0;

      console.log("total page", totalPages);
      setPage(currentPage);
      setTotal(totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [page, selectedOccupation, searchInputApi]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === '') {
      setSearchInputApi('');
    }
  }, [searchInput]);

  const openModal = (data) => {
    setSection("");
    setText("");
    setLink("");
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false); // Function to close modal
  const closeModalEdit = () => setIsModalOpenEdit(false); // Function to close modal

  const toggleStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/cms/contactUs/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("role response", response);
      toast.success("Status Updated");
      fetchInvestorDetails();
    } catch (err) {
      toast.error(err?.response?.data.message);
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  // Update the SECTIONS array to use consistent values
  const SECTIONS = [
    { value: "email", label: "Email" },
    { value: "contact_number", label: "Contact Number" }, 
    { value: "address", label: "Address" }
  ];

  // Add validation helper function
  const validateField = (section, value) => {
    if (!value) return "This field is required";
    
    switch (section) {
      case "email":
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value) ? "" : "Please enter a valid email address";
        
      case "contact_number":
        // Updated regex for Indian mobile numbers:
        // - Must start with 6, 7, 8, or 9
        // - Must be exactly 10 digits
        const phoneRegex = /^[6-9]\d{9}$/;
        return phoneRegex.test(value) 
          ? "" 
          : "Please enter a valid mobile number";
        
      case "address":
        return value.trim() ? "" : "Address is required";
        
      default:
        return "";
    }
  };

  // Update the addNewRole function
  const addNewRole = async (type) => {
    // Prevent multiple submissions
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true); // Set loading state

    const error = validateField(section, text);
    
    if (error) {
      if (!toast.isActive(toastIds.validationError)) {
        toast.error(error, { toastId: toastIds.validationError });
      }
      setIsSubmitting(false);
      return;
    }

    console.log("type", type);
    let isError = false;

    // Check if section, text, or link are empty
    if (!section && !text) {
      if (!toast.isActive(toastIds.validationError)) {
        toast.error("Fill all fields before adding.", { toastId: toastIds.validationError });
      }
      isError = true;
    } else {
      // Check Section Validation
      if (!section) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error("Section cannot be empty.", { toastId: toastIds.validationError });
        }
        isError = true;
      }

      // Check Text Validation
      if (!text || text.length > 1000) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error(
            !text
              ? "Text cannot be empty."
              : "Text must not exceed 1000 characters.",
            { toastId: toastIds.validationError }
          );
        }
        isError = true;
      }

      // Check Link Validation
      if (link?.length > 2000) {
        if (!toast.isActive(toastIds.validationError)) {
          toast.error(
            !link
              ? "Link cannot be empty."
              : "Link must not exceed 2000 characters.",
            { toastId: toastIds.validationError }
          );
        }
        isError = true;
      }
    }

    // Stop execution if any validation error exists
    if (isError) {
      setIsSubmitting(false);
      return;
    }

    const endpoint = `${base_url}/${api_type}/cms/contactUs`;
    const endpointEdit = `${base_url}/${api_type}/cms/contactUs/${editRole?.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    const payload = {
      section: section,
      text: text,
      link: link,
    };

    console.log("editRole------------", editRole);

    try {
      const response =
        type === "edit"
          ? await axios.put(
              endpointEdit,
              {
                section: section,
                text: text,
                link: link,
              },
              { headers }
            )
          : await axios.post(endpoint, payload, { headers });

      // Reset input fields and states
      setNewRole("");
      setEditRole({ id: "", name: "" });
      console.log("role response", response);
      toast.success(response?.data?.message);
      fetchInvestorDetails();
      setIsModalOpen(false);
      setIsModalOpenEdit(false);
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.response?.data?.message || "Failed to add role");
      setError(err?.message || "An error occurred");
    } finally {
      setIsSubmitting(false); // Reset loading state
    }
  };

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    // columnHelper.accessor("id", {
    //   cell: (info) => info.renderValue(),
    //   header: () => <span>Sr. No.</span>,
    // }),
    columnHelper.accessor("section", {
      cell: (info) => info.renderValue(),
      header: () => <span>Section</span>,
    }),
    columnHelper.accessor("text", {
      cell: (info) => info.renderValue(),
      header: () => <span>Text</span>,
    }),
    columnHelper.accessor("link", {
      cell: (info) => info.renderValue(),
      header: () => <span>Link</span>,
    }),
    columnHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        console.log("status", status);
        console.log("info", info);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm`}
          >
            {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
            <ToggleButton
              value={status}
              handleToggleStatus={toggleStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("investorid", uniqueId);
        // const NavigateScheme = (uniqueId) => {
        //   navigate("/registration/investor/details", {
        //     state: {
        //       uniqueId: uniqueId,
        //     },
        //   });
        // };
        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  updateRole({
                    id: uniqueId,
                    section: info.row.original.section,
                    text: info.row.original.text,
                    link: info.row.original.link,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this contact?")) {
                  axios.delete(`${base_url}/${api_type}/cms/contactUs/${uniqueId}`, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Contact deleted successfully");
                    fetchInvestorDetails();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete contact");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };
  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  console.log(searchInputApi, "searchinpu");
  return (
    <div className=" mt-[60px] px-4">
      <div className="bg-white px-8  mt-4 rounded-[10px] border">
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 py-4 gap-y-4">
            <div className="flex gap-2">
              <div class="flex gap-0.5">
                <h1 className="text-[#252C32] text-[20px] font-bold">
                  Contact us{" "}
                </h1>
              </div>
              {/* <div className="flex items-center">
                <div className="w-[136px]">
                  <SelectButton
                    options={optiosStatus}
                    selectedValue={selectedOccupation}
                    onSelect={handleSelectOccupation}
                  />
                </div>
              </div> */}
            </div>
            {userPermissionData?.user?.addRole && (
              <div class="flex items-center bg-[#035C98]  rounded-[8px]">
                <button
                  class="btn flex items-center gap-2 text-white font-bold"
                  onClick={openModal}
                >
                  <img src={plus} alt="plus" className="w-5 h-5" />
                  Add New
                </button>
              </div>
            )}
            {/* Modal Component */}
            {isModalOpen && (
              <ReusableModal
                content={
                  <div className="w-full max-w-md mx-auto bg-white ">
                    <h2 className="text-center text-[24px] font-semibold mb-4">
                      Add Contact us
                    </h2>

                    <label className="block text-[15px] font-normal mb-2">
                      Section
                    </label>
                    <select
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      name="section"
                      value={section}
                      onChange={(e) => setSection(e.target.value)}
                    >
                      <option value="">Select section</option>
                      {SECTIONS.map((section) => (
                        <option key={section.value} value={section.value}>
                          {section.label}
                        </option>
                      ))}
                    </select>

                    <label className="block text-[15px] font-normal mt-4 mb-2">
                      {section === "email" ? "Email" :
                       section === "contact_number" ? "Contact Number" :
                       section === "address" ? "Address" : "Text"}
                    </label>
                    <input
                      type={section === "email" ? "email" : "text"}
                      value={text}
                      placeholder={
                        section === "email" ? "Enter email address" :
                        section === "contact_number" ? "Enter 10-digit mobile number" :
                        section === "address" ? "Enter address" : "Enter text"
                      }
                      maxLength={section === "contact_number" ? 10 : undefined}
                      onKeyPress={(e) => {
                        if (section === "contact_number") {
                          // Allow only numbers
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }
                      }}
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      onChange={(e) => {
                        const value = section === "email" ? e.target.value.toLowerCase() : e.target.value;
                        setText(value);
                      }}
                    />

                    <label className="block text-[15px] font-normal mt-4 mb-2">
                      Link (Optional)
                    </label>
                    <input
                      type="text"
                      value={link}
                      placeholder="Enter link (optional)"
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </div>
                }
                onUpload={() => addNewRole("new")}
                ButtonValue={isSubmitting ? "Adding..." : "Add"}
                onClose={closeModal}
                disabled={isSubmitting}
              />
            )}
            {isModalOpenEdit && (
              <ReusableModal
                title="Update Contact"
                content={
                  <div className="w-full max-w-md mx-auto bg-white mt-6">
                    <label className="block text-[15px] font-normal mb-2">
                      Section
                    </label>
                    <select
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      name="section"
                      value={section}
                      onChange={(e) => setSection(e.target.value)}
                    >
                      <option value="">Select section</option>
                      {SECTIONS.map((section) => (
                        <option key={section.value} value={section.value}>
                          {section.label}
                        </option>
                      ))}
                    </select>

                    <label className="block text-[15px] font-normal mt-4 mb-2">
                      {section === "email" ? "Email" :
                       section === "contact_number" ? "Contact Number" :
                       section === "address" ? "Address" : "Text"}
                    </label>
                    <input
                      type={section === "email" ? "email" : "text"}
                      value={text}
                      placeholder={
                        section === "email" ? "Enter email address" :
                        section === "contact_number" ? "Enter 10-digit mobile number" :
                        section === "address" ? "Enter address" : "Enter text"
                      }
                      maxLength={section === "contact_number" ? 10 : undefined}
                      onKeyPress={(e) => {
                        if (section === "contact_number") {
                          // Allow only numbers
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }
                      }}
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      onChange={(e) => {
                        const value = section === "email" ? e.target.value.toLowerCase() : e.target.value;
                        setText(value);
                      }}
                    />

                    <label className="block text-[15px] font-normal mt-4 mb-2">
                      Link (Optional)
                    </label>
                    <input
                      type="text"
                      value={link}
                      placeholder="Enter link (optional)"
                      className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                      onChange={(e) => setLink(e.target.value)}
                    />
                  </div>
                }
                onUpload={() => addNewRole("edit")}
                ButtonValue="Update"
                onClose={closeModalEdit}
              />
            )}
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        <ReactTable
          key={JSON?.stringify(investorDetails)}
          defaultData={investorDetails || []}
          columns={columns}
        />
      </div>

      {/* {investorDetails?.length > 0 && (
        <div className="w-auto">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
          />
        </div>
      )} */}
    </div>
  );
}

export default UserManagementMain;
